import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { getTenantFromSubdomain } from '../utils/tenant';
import InvalidTenant from '../pages/InvalidTenant';

export const TenantContext = createContext();

export const TenantProvider = ({ children }) => {
  const [tenant, setTenant] = useState(null);
  const [tenantType, setTenantType] = useState(null);
  const [loading, setLoading] = useState(true);
  const [invalidTenant, setInvalidTenant] = useState(false);

  useEffect(() => {
    const validateTenant = async () => {
      const subdomain = getTenantFromSubdomain();

      if (!subdomain) {
        // No valid subdomain extracted
        setInvalidTenant(true);
        setLoading(false);
        return;
      }

      try {
        const useProduction = process.env.REACT_APP_USE_PRODUCTION === 'true';
        const apiUrl = useProduction 
          ? process.env.REACT_APP_PROD_API_URL 
          : process.env.REACT_APP_DEV_API_URL;

        const response = await axios.post(`${apiUrl}/public/validate-tenant`, {
          subdomain
        });

        if (response.data.success) {
          setTenantType(response.data.type);
          // Server returns the per-tenant tenant_type (school/university/college/etc)
          // as `type`. Previously this only saved `tenant` for the literal value
          // 'tenant', so any real tenant_type left the tenant object null and
          // downstream components couldn't read tenant.tenant_type.
          if (response.data.tenant) {
            setTenant(response.data.tenant);
          }
        } else {
          setInvalidTenant(true);
        }
      } catch (error) {
        console.error('Tenant validation failed:', error);
        setInvalidTenant(true);
      } finally {
        setLoading(false);
      }
    };

    validateTenant();
  }, []);

  if (loading) {
    return <div className="loading-screen" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>Validating environment...</div>;
  }

  if (invalidTenant) {
    return <InvalidTenant />;
  }

  return (
    <TenantContext.Provider value={{ tenant, tenantType }}>
      {children}
    </TenantContext.Provider>
  );
};
